import type { TPricingElement } from '@shared/dream-components';

// SSR/Suspense fallback for the lazy Pricing node: reserves tier-card-shaped
// space so the client-side swap doesn't shift layout.
const PricingSkeleton = ({ node }: { node: TPricingElement }) => {
  const tierCount = Math.min(Math.max(node.attrs?.data?.length ?? 1, 1), 3);

  return (
    <div className="flex w-full flex-wrap justify-center gap-6 py-8" aria-hidden="true">
      {Array.from({ length: tierCount }, (_, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: static placeholder list
        <div key={index} className="h-96 w-80 max-w-full animate-pulse rounded-xl bg-black/5" />
      ))}
    </div>
  );
};

export default PricingSkeleton;
